import React from 'react';
import { cn } from '../../lib/utils';

const RailHeader = ({ title, actionLabel, onAction, className }) => (
  <div
    className={cn(
      'mb-4 flex items-center justify-between gap-4',
      className
    )}
  >
    <h2 className="text-xl font-semibold text-foreground">{title}</h2>
    {actionLabel && onAction && (
      <button
        type="button"
        onClick={onAction}
        className="shrink-0 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default RailHeader;
